import { cn, Popup as PopupUI } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import * as Profile from '@Queries/Profile';
import useRouter from '@Navigation/useRouter';
import Link from '@Navigation/Link';
import styles from './BonusPopup.module.css';

import type { FC } from 'react';
import type { PopupProps } from '@divlab/divanui';

export interface BonusPopupProps extends PopupProps {
  onClick?: () => void;
}

const BonusPopup: FC<BonusPopupProps> = (props) => {
  const { onClick, className, ...restProps } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const profile = Profile.useProfile();

  return (
    <PopupUI {...restProps} data-testid='information-bonus' className={cn(styles.main, className)}>
      {profile.data ? (
        <p className={styles.text}>
          {t('ui.bonuses.popup.not-authorized')}
          <Link to={router.club} target='_blank' view='native'>
            {t('ui.bonuses.popup.divan-club-link')}
          </Link>
        </p>
      ) : (
        <p className={styles.text}>
          <Link view='native' onClick={onClick} to={!!onClick ? '' : '#authorization'}>
            {t('ui.bonuses.popup.authorized.auth-link')}
          </Link>
          {t('ui.bonuses.popup.authorized.text')}
          <Link to={router.club} target='_blank' view='native'>
            {t('ui.bonuses.popup.divan-club-link')}
          </Link>
        </p>
      )}
    </PopupUI>
  );
};

export default BonusPopup;
